import { UserInterface } from './user.interface';
import { Model } from '../../api/model';
import { ApiService } from '../../api/api.service';
import { RoleModel } from './role.model';

export class UserModel extends Model implements UserInterface {

    public id: number;

    public name: string;

    public tenant_scope;

    public tenants;

    public root_tenants;

    public email: string;

    public created_at: string;

    public permissions = {};

    public datatable_preferences;

    public constructor(data: Object = {}, _service?: ApiService) {
        super(data, _service);

        this.extractPermissions();
    }

    public getId(): number {
        return this.id;
    }

    public getName(): string {
        return this.name;
    }

    /**
     * Returns a boolean whether the user has the given permission
     *
     * @param permission
     * @returns {boolean}
     */
    public can(permission): boolean {
        return !!this.permissions['entities.' + permission]
            || !!this.permissions[permission];
    }

    /**
     * Returns whether the user has the given role
     *
     * @param roleName
     * @returns {boolean}
     */
    public hasRole(roleName): boolean {
        return !!this.roles()
            .find('name', roleName);
    }

    public hasRoleIn(role: string | Array<string>): boolean {
        if (typeof role === 'string') {
            role = [role];
        }

        for (const name of role) {
            if (!!this.roles().find('name', name)) {
                return true;
            }
        }

        return false;
    }

    private extractPermissions() {
        if (this.roles().count() > 0) {
            this.roles().each(role => {
                if (role.perms && role.perms.length) {
                    role.perms.forEach(perm => {
                        if (this.permissions[perm.name] === undefined) {
                            this.permissions[perm.name] = perm;
                        }
                    });
                }
            });
        }
    }

    public roles() {
        return this.hasMany(RoleModel, 'roles', {userId: this.id});
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/models/user.model.ts